<div class="py-4">
  <mat-card-header class="flex align-items-center">
    <shared-title>
      @if (issParking() === 1) {
        Nuevo Parqueo
      } @else {
        Nuevo puesto de trabajo
      }
    </shared-title>
    <button
      (click)="clearForm()"
      mat-icon-button
      matTooltip="Limpiar formulario"
      matTooltipPosition="right"
      class="ml-5">
      <mat-icon>cleaning_services</mat-icon>
    </button>
  </mat-card-header>

  <mat-card-content class="mt-5">
    <form [formGroup]="formNewJob" (ngSubmit)="onSubmit()">
      <div class="grid">
        <div
          class="w-full gap-1 flex flex-column sm:flex-column md:flex-row lg:flex-row xl:flex-row">
          <shared-input
            class="w-full"
            [labelTitle]="'Nombre'"
            [control]="$any(formNewJob.get('name'))" />
        </div>

        <div
          class="w-full gap-1 flex flex-column sm:flex-column md:flex-row lg:flex-row xl:flex-row"
          style="margin-bottom: 18px">
          <shared-input
            class="w-full"
            [labelTitle]="'Descripción'"
            [control]="$any(formNewJob.get('description'))" />
          <shared-input
            class="w-full"
            type="text"
            [labelTitle]="'Teléfono'"
            [control]="$any(formNewJob.get('phone'))" />
        </div>

        <mat-form-field class="col-6" appearance="outline">
          <mat-label> Coordenada X</mat-label>
          <input matInput formControlName="x" />
        </mat-form-field>

        <mat-form-field class="col-6" appearance="outline">
          <mat-label>Coordenada Y</mat-label>
          <input matInput formControlName="y" />
        </mat-form-field>

        <div
          class="w-full gap-1 flex flex-column sm:flex-column md:flex-row lg:flex-row xl:flex-row">
          <shared-select
            class="w-full"
            [labelTitle]="'Tipo de puesto de trabajo'"
            [control]="$any(formNewJob.get('workplacetypeid'))"
            [options]="ptypeJobs"
            [selectId]="'workplacetypeid'" />

          <shared-select
            class="w-full"
            [labelTitle]="'Grupo de lugar de trabajo'"
            [control]="$any(formNewJob.get('workplacegroupid'))"
            [options]="workplaceGroups"
            [selectId]="'id'" />
        </div>

        <div
          class="w-full gap-1 flex flex-column sm:flex-column md:flex-row lg:flex-row xl:flex-row">
          <mat-selection-list class="col-12 text-center">
            <mat-label>
              @if (issParking() === 1) {
                Día en los que esta disponible este parqueo
              } @else {
                Día en los que esta disponible este puesto de trabajo:
              }
            </mat-label>
            <div class="day-checkboxes">
              <div class="checkbox-item text-center">
                <mat-checkbox formControlName="monday"></mat-checkbox>
                <span>L</span>
              </div>
              <div class="checkbox-item text-center">
                <mat-checkbox formControlName="tuesday"></mat-checkbox>
                <span>M</span>
              </div>
              <div class="checkbox-item text-center">
                <mat-checkbox
                  formControlName="wednesday"
                  [checked]="true"></mat-checkbox>
                <span>M</span>
              </div>
              <div class="checkbox-item text-center">
                <mat-checkbox formControlName="thursday"></mat-checkbox>
                <span>J</span>
              </div>
              <div class="checkbox-item text-center">
                <mat-checkbox formControlName="friday"></mat-checkbox>
                <span>V</span>
              </div>
              <div class="checkbox-item text-center">
                <mat-checkbox formControlName="saturday"></mat-checkbox>
                <span>S</span>
              </div>
              <div class="checkbox-item text-center">
                <mat-checkbox formControlName="sunday"></mat-checkbox>
                <span>D</span>
              </div>
            </div>
          </mat-selection-list>
        </div>
        @if (issParking() === 1) {
          <div
            class="w-full gap-1 flex flex-column sm:flex-column md:flex-row lg:flex-row xl:flex-row">
            <mat-selection-list class="col-12">
              <mat-label>
                Reservar parqueo para un usuario en especifico.
              </mat-label>
            </mat-selection-list>
          </div>

          <div
            class="w-full gap-1 flex flex-column justify-content-center align-content-left">
            <mat-form-field class="col-10" appearance="outline">
              <mat-label>Clientes con parqueo</mat-label>
              <mat-select formControlName="assignedWorker">
                @for (item of workerisparking(); track item) {
                  <mat-option [value]="item.workerId">
                    {{ item.firstName }} {{ item.lastName }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>

          <div
            class="w-full gap-1 flex flex-column justify-content-center align-content-left">
            <section>
              <mat-label>
                Rango de fechas en que estará libre el parqueo
              </mat-label>
              <mat-form-field class="col-10" appearance="outline">
                <mat-label>Ingrese el rango de fechas</mat-label>
                <mat-date-range-input [rangePicker]="picker">
                  <input
                    matStartDate
                    formControlName="startDate"
                    placeholder="Start date" />
                  <input
                    matEndDate
                    formControlName="endDate"
                    placeholder="End date" />
                </mat-date-range-input>
                <mat-datepicker-toggle
                  matIconSuffix
                  [for]="picker"></mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>
              </mat-form-field>
            </section>
          </div>
        }
      </div>

      <mat-dialog-actions class="flex justify-content-evenly pb-6">
        <shared-button
          class="flex"
          mat-dialog-close
          [icon]="'clear'"
          [typeBtn]="'button'"
          [color]="'warn'"
          >Cancelar</shared-button
        >
        <shared-button
          [disabled]="!formNewJob.valid"
          class="flex"
          [icon]="'check'"
          [typeBtn]="'submit'"
          [color]="'accent'"
          >Guardar</shared-button
        >
      </mat-dialog-actions>
    </form>
  </mat-card-content>
</div>
